export default "__VITE_ASSET__SfXFoxIH__"